// extracted by mini-css-extract-plugin
export var active = "_ff-7";
export var container = "_ff-0";
export var evenWidth = "_ff-4";
export var large = "_ff-5";
export var outlet = "_ff-8";
export var slide = "_ff-2";
export var small = "_ff-6";
export var tab = "_ff-3";
export var tabs = "_ff-1";